import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';
import { objectAsParams } from '../../../helpers';

class RelacionFacturas extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'Ventas', saveUrl: 'Ventas/save', backUrl: '/Catalogo' },
      new Form([
        Form.Field('date', 'startDate', 'Fecha Inicial', '', [Validators.required], 6),
        Form.Field('date', 'endDate', 'Fecha Final', '', [Validators.required], 6),
        Form.Field('autocomplete', 'id_cliente', 'Cliente', '', [Validators.required], 12, []),
      ], ['Descargar Excel'], 'Relacion de Facturas'), this.formData
    )
  }

  formData = async (form) => {
    const params = {};
    let newForm = form;
    if (this.formCli) {
      params["cli"] = this.formCli;
      this.formCli = null;
    }

    const Res = await Http.get(`nota-credito/form?${objectAsParams(params)}`);
    if (!Res.error) {
      const { clientes } = Res.data;
      if (clientes) {
        newForm = Form.FieldOptions(newForm, 'id_cliente', clientes, 'id', 'cliente_rsocial');
      }
    }
    newForm = Form.ValueChange(newForm, {
      id_cliente: async (field) => { (field.ValueAt && field.ValueAt.length > 2) && this.clienteChange(field, 'formCli')},
    });
    return newForm;
  }

  clienteChange = async (field, variable) => {
    this[variable] = field.ValueAt;
    this.setState({ FormData: await this.formData(this.state.FormData) });
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    const { startDate, endDate, id_cliente } = vals;
    const start = moment(startDate).format('YYYY-MM-DD');
    const end = moment(endDate).format('YYYY-MM-DD');
    const Resp = await Http.get(`reporte/relacion-facturas?q=1&start_date=${start}&end_date=${end}&id_cliente=${id_cliente}`, true, 'arraybuffer')
    let response = null;
    try {
      let decodedString = String.fromCharCode.apply(null, new Uint8Array(Resp));
      response = JSON.parse(decodedString);
    } catch (error) {
      console.log(error);
    }
    if (response && response.error) {
      this.setState({ sbOpen: true, sbMsg: response.errMsg});
    } else {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `reporte_relacion_facturas_${start}-${end}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(RelacionFacturas)
